import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { FormInputText } from '@/components/form/FormInputText';

/* Location Info
    address: '',
    city: '',
    zipcode: '',
    state: '',
    country: '',
*/

export const LocationInfoStep = () => {
    const { control } = useFormContext();

    return (
        <Grid container spacing={3}>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="address"
                        control={control}
                        label="Street Address"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'address',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="city"
                        control={control}
                        label="City"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'city',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="zipcode"
                        control={control}
                        label="Zip(Postal) Code"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'zipcode',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                maxLength: {
                                    value: 12,
                                    message: 'Maximum 12 characters',
                                },
                                minLength: {
                                    value: 5,
                                    message: 'Minimum 5 characters',
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="state"
                        control={control}
                        label="State/Province"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'state',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="country"
                        control={control}
                        label="Country"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'country',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};
